import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ChevronRight } from 'lucide-react';
import { Button } from './ui/Button';
import { DonutChart } from './DonutChart';
import { GlassCard } from './ui/GlassCard';
export function Hero() {
  return <section className="relative z-10 min-h-screen flex items-center justify-center px-4 pt-20 pb-20 overflow-hidden" data-id="element-42">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-43">
        {/* Left Content */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="space-y-8" data-id="element-44">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm" data-id="element-45">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" data-id="element-46" />
            <span className="text-sm font-medium text-emerald-100" data-id="element-47">
              Nowa generacja analityki
            </span>
          </motion.div>

          <h1 className="text-5xl md:text-7xl font-bold leading-tight tracking-tight" data-id="element-48">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-emerald-100 to-slate-300" data-id="element-49">
              Przyszłość
            </span>
            <br data-id="element-50" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-emerald-600" data-id="element-51">
              zarządzania
            </span>
            <br data-id="element-52" />
            subskrypcjami
          </h1>

          <p className="text-lg md:text-xl text-slate-300 max-w-xl leading-relaxed" data-id="element-53">
            Kompleksowa platforma dla nowoczesnych firm SaaS. Automatyzacja,
            analityka i skalowalność w jednym, pięknym interfejsie.
          </p>

          <div className="flex flex-wrap gap-4" data-id="element-54">
            <Button variant="primary" className="h-12 px-8 text-base" data-id="element-55">
              Rozpocznij teraz <ArrowRight className="w-4 h-4" data-id="element-56" />
            </Button>
            <Button variant="outline" className="h-12 px-8 text-base" data-id="element-57">
              Zobacz demo
            </Button>
          </div>

          <div className="pt-8 flex items-center gap-4 text-sm text-slate-400" data-id="element-58">
            <div className="flex -space-x-2" data-id="element-59">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-slate-900 bg-slate-700 flex items-center justify-center text-xs overflow-hidden" data-id="element-60">
                  <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${i}`} alt="User" data-id="element-61" />
                </div>)}
            </div>
            <p data-id="element-62">
              Zaufane przez{' '}
              <span className="text-white font-semibold" data-id="element-63">500+</span> firm w
              Polsce
            </p>
          </div>
        </motion.div>

        {/* Right Visual */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8,
        rotate: -5
      }} animate={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut',
        delay: 0.2
      }} className="relative hidden lg:block" data-id="element-64">
          {/* Main Dashboard Card */}
          <GlassCard className="p-8 relative z-20 bg-slate-900/40 border-slate-700/50" data-id="element-65">
            <div className="flex justify-between items-center mb-8" data-id="element-66">
              <div data-id="element-67">
                <h3 className="text-xl font-semibold text-white" data-id="element-68">
                  Przychody MRR
                </h3>
                <p className="text-sm text-slate-400" data-id="element-69">Ostatnie 30 dni</p>
              </div>
              <div className="px-3 py-1 rounded-full bg-emerald-500/20 text-emerald-400 text-sm font-medium" data-id="element-70">
                +12.5%
              </div>
            </div>

            <div className="flex items-center gap-8" data-id="element-71">
              <DonutChart data-id="element-72" />
              <div className="space-y-4 flex-1" data-id="element-73">
                <div className="flex justify-between items-center" data-id="element-74">
                  <span className="text-sm text-slate-300" data-id="element-75">Active</span>
                  <span className="text-sm font-bold text-white" data-id="element-76">1,240</span>
                </div>
                <div className="w-full h-2 bg-slate-700 rounded-full overflow-hidden" data-id="element-77">
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: '65%'
                }} transition={{
                  duration: 1,
                  delay: 0.5
                }} className="h-full bg-emerald-500" data-id="element-78" />
                </div>

                <div className="flex justify-between items-center" data-id="element-79">
                  <span className="text-sm text-slate-300" data-id="element-80">Trial</span>
                  <span className="text-sm font-bold text-white" data-id="element-81">380</span>
                </div>
                <div className="w-full h-2 bg-slate-700 rounded-full overflow-hidden" data-id="element-82">
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: '20%'
                }} transition={{
                  duration: 1,
                  delay: 0.7
                }} className="h-full bg-emerald-400" data-id="element-83" />
                </div>
              </div>
            </div>
          </GlassCard>

          {/* Floating Elements */}
          <motion.div animate={{
          y: [0, -15, 0]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute -top-12 -right-8 z-30" data-id="element-84">
            <GlassCard className="p-4 flex items-center gap-3 !bg-slate-800/80" data-id="element-85">
              <div className="w-10 h-10 rounded-full bg-emerald-500/20 flex items-center justify-center text-emerald-400" data-id="element-86">
                <ChevronRight className="w-6 h-6" data-id="element-87" />
              </div>
              <div data-id="element-88">
                <p className="text-xs text-slate-400" data-id="element-89">Nowa subskrypcja</p>
                <p className="text-sm font-bold text-white" data-id="element-90">+449 PLN</p>
              </div>
            </GlassCard>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}